import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import type { InputMappingGroup } from '@/features/InputMapping/types';
import { formatChoice } from '@/utils/formatters/simpleChoice';

export const beitragsreduzierungsGroupMapping: InputMappingGroup = {
  icon: 'badge-percent',
  label: 'Mögliche Beitragsreduzierungen',
  infos: [
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            label: 'Vorversicherung',
            path: 'vorversicherung',
            formatter: formatChoice(SIMPLE_CHOICE.VORVERSICHERUNG),
          },
        ],
      },

      requiredPaths: ['vorversicherung'],
      requiredOr: true,
    },
  ],
};
